import useHealthRecommendations from 'hooks/useHealthRecommendations';

export default function HealthInfo() {
  const { img, title, desc } = useHealthRecommendations();

  return (
    <div className='grid w-full h-full place-items-center'>
      <div className='flex flex-col items-center justify-center py-10 mx-auto'>
        <div className='mb-4 size-28'>
          <img src={img} alt={title} className='object-cover w-full h-full' />
        </div>

        <p className='h-20 text-sm leading-tight text-center'>
          <span className='font-semibold'>{title}: </span> {desc}
        </p>
      </div>
    </div>
  );
}
